import { routes } from "@login/routes/routes";
import { Routes, Route } from "@shared/react-router-dom/react-router-dom";
import type { Flipper } from "@shared/types/flipper";

interface Props {
  flippers: Flipper[];
}

const Pages = ({ flippers }: Props) => {
  return (
    <Routes>
      {routes(flippers).map(({ key, path, element }) => {
        return <Route key={key} path={path} element={element} />;
      })}
    </Routes>
  );
};

export { Pages };
